import { Icon, IconProps } from '@eluve/components';
import { BlockType } from '@eluve/llm-outputs';

export const BlockTypeIcons: Record<BlockType, IconProps['name']> = {
  group: 'BoxSelect',
  text: 'Type',
  checkbox: 'SquareCheckBig',
  range: 'SlidersHorizontal',
};

export const BlockTypeIcon: React.FC<{
  type: BlockType;
  className?: string;
}> = ({ type, className }) => {
  return <Icon name={BlockTypeIcons[type]} className={className} size="xs" />;
};
